import { UserService } from "@/services/user.service";
import { TokenService } from "@/services/storage.service";
import ApiService from '@/services/api.service'

import router from "@/router/router";
import { bus } from "@/main";
import EmployeeService from "@/services/employee.service";
import i18n from "@/core/plugins/vue-i18n";

const state = {
  userAllData: {},
  user: {
    permissions: [],
  },
  unreadStatuses: {
    total: 0,
    list: [],
  },
  token: TokenService.getToken(),
  show401Error: false,
  userName: TokenService.getUserName(),
  authenticating: false,
  rules: [],
  userId: null,
  authenticationErrorCode: 0,
  authenticationError: "",
  getFormDate: "",
  currentVar: false,
  isCurrentCode: "",
  resNextRegister: "",
  isRegisterback: true,
  isRegisterReset: false,
};

const getters = {
  loggedIn: (state) => {
    return !!state.token;
  },

  authenticationErrorCode: (state) => {
    return state.authenticationErrorCode;
  },

  authenticationError: (state) => {
    return state.authenticationError;
  },

  authenticating: (state) => {
    return state.authenticating;
  },

  userPermissions: (state) => {
    return state.user.permissions;
  },
};

const actions = {
  login({ commit }, userData) {
    return new Promise(async (response, reject) => {
      commit("loginRequest");
      try {
        const user = await UserService.login(userData);
        await commit("loginSuccess", user);
        let route = router.history.current;
        if (route.name != "vacancy") {
          router.push("/profile");
        } else {
          if (route.query.vId) {
            let res = await EmployeeService.selectVakant(
              parseInt(route.query.vId)
            );
            if (res.data) {
              bus.$toast.success(i18n.t("succes.saved"));
              router.push("/profile");
            }
          }
        }
        response(true);
      } catch (e) {
        let route = router.history.current;
        if (route.name == "vacancy") {
          if (e.request && e.request.response == "selected") {
            bus.$toast.info(i18n.t("warning.selectInfo"));
            router.push(route.path);
            window.location.reload();
          } else {
            window.location.reload();
            bus.$toast.info(i18n.t("warning.warInfo"));
            bus.$router.push("/profile");
          }
        } else {
        }

        reject(true);
      }
    });
  },

  async registerReset({ commit }) {
    if (state.getFormDate.phone !== undefined) {
      await commit("registerPhone", state.getFormDate);
    } else if (state.getFormDate.email !== undefined) {
      await commit("register", state.getFormDate);
    }
  },
  async confirmBack({ commit }, data) {
    state.isRegisterback = data;
  },
  async confirmReset({ commit }, data) {
    state.isRegisterReset = data;
  },
  async register({ commit }, userData) {
    await commit("setFormdate", userData);
    try {
      const user = await UserService.register(userData);
      if (user === "success") {
        var data = {
          boolType: true,
          text: "phone number",
        };
        commit("setCurrentVar", data);
      }
      return true;
    } catch (e) {
      commit("loginError", {
        errorCode: e.errorCode,
        errorMessage: e.message,
      });
      return false;
    }
  },
  async registerPhone({ commit }, userData) {
    await commit("setFormdate", userData);
    try {
      const user = await UserService.registerPhone(userData);
      if (user === "success") {
        var data = {
          boolType: true,
          text: "phone number",
        };
        commit("setCurrentVar", data);
      }

      return true;
    } catch (e) {
      commit("loginError", {
        errorCode: e.errorCode,
        errorMessage: e.message,
      });
      return false;
    }
  },

  async nextRegister({ commit }, userData) {
    try {
      const res = await UserService.nextRegister(userData);
      commit("setNextRegistr", res);
      return true;
    } catch (e) {
      commit("loginError", {
        errorCode: e.errorCode,
        errorMessage: e.message,
      });
      return false;
    }
  },
  async nextRegisterBack({ commit }, userData) {
    try {
      commit("setNextRegistr", userData);
      return true;
    } catch (e) {
      commit("loginError", {
        errorCode: e.errorCode,
        errorMessage: e.message,
      });
      return false;
    }
  },
  async confirmation({ commit, dispatch }, confirmCode) {
    state.resNextRegister = "";

    try {
      const user = await UserService.confirm(confirmCode, state.getFormDate);
      let dataUser = {
        username: user.username,
        password: user.password,
      };
      await dispatch("login", dataUser);
      return true;
    } catch (e) {
      commit("loginError", {
        errorCode: e.errorCode,
        errorMessage: e.message,
      });
      return false;
    }
  },

  async loginByToken({ commit }, userData) {
    commit("loginRequest");
    try {
      const user = await UserService.loginByEsp(userData);

      await commit("loginSuccess", user);
      let routeHistory = router.history.current.query.redirect;
      router.push(routeHistory ? routeHistory : "/profile");
      return true;
    } catch (e) {
      commit("loginError", {
        errorCode: e.errorCode,
        errorMessage: e.message,
      });
      return false;
    }
  },
  async tokenOneId({ commit, dispatch }, data) {
    commit("loginRequest");
    try {
      await UserService.loginRequestToOneId(data.code, data.state).then(async (res) => {
        if (res.data.token) {
          TokenService.saveToken(res.data.token)
          ApiService.setHeader();
          commit("loginSuccess", res.data)
          await router.push({ path: "/profile" });
          return res.data
        } else {
          await router.push({ name: "Home" });
          return res.data
        }
      });
    } catch (e) {
      commit("loginError", {
        errorCode: e.errorCode,
        errorMessage: e.message,
      });
      bus.$toast.error(e.response.data.message)
      router.push("/?page=login");
      return e;
    }
  },
  logout({ commit }) {
    UserService.logout();
    commit("logoutSuccess");
  },
};

const mutations = {
  setUnreadStatuses(state, data) {
    if (data.READ) {
      if (data.READ != "READ") {
        if (data.data.list.length > 0) {
          data.data.list.forEach((el) => {
            bus.$toast.success(el.reason);
          });
        }
      }
    }

    state.unreadStatuses = {
      ...data.data,
    };
  },
  setNextRegistr(state, res) {
    state.resNextRegister = res;
  },
  show401ErorMessage(state, boolean) {
    state.show401Error = boolean;
  },

  loginRequest(state) {
    state.authenticating = true;
    state.authenticationError = "";
    state.authenticationErrorCode = 0;
  },
  setFormdate(state, formDate) {
    state.getFormDate = formDate;
  },
  setCurrentVar(state, data) {
    state.currentVar = data.boolType;
    state.isCurrentCode = data.text;
  },

  loginSuccess(state, user) {
    state.user = user;
    state.userId = user.id;
    state.token = user.token;
    state.authenticating = false;
    state.userName = TokenService.getUserName();
  },

  loginError(state, { errorCode, errorMessage }) {
    state.authenticating = false;
    state.authenticationErrorCode = errorCode;
    state.authenticationError = errorMessage;
  },

  logoutSuccess(state) {
    state.token = "";
    state.rules = [];
    state.userId = null;
    window.location.reload();
  },
};

export const auth = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
